<div class="raw-content-page-layout status-state" [attr.id]="headId" [style.--status-accent]="accentColor">
  <div class="status-illustration">
    <img [src]="logo" [alt]="BRAND.name"/>
  </div>

  <h1 class="status-title">{{ title }}</h1>
  <p class="status-subtitle" *ngFor="let line of subtitleLines">{{ line }}</p>

  <!-- Outline pill (same as the home CTAs); the status accent recolours the
       border and its hover lift. -->
  <div class="status-action codigrate-button" (click)="action.emit()">
    <app-arrow-right [height]="16"></app-arrow-right>
    <p>{{ buttonText }}</p>
  </div>

  <!-- Helpful links (404). -->
  <nav class="status-links" *ngIf="links?.length" aria-label="Helpful links">
    <a *ngFor="let l of links" [routerLink]="l.url" class="status-link">{{ l.label }}</a>
  </nav>
</div>
